import { type ComponentProps } from 'react';
import { styled } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useUpMedia } from '../hooks';
import { getB2BLobbyName } from '../utils/consts.ts';
import { DesktopText, MobileText } from './texts';

export type B2BRefreshMessageProps = ComponentProps<typeof Wrapper>;

const B2BRefreshMessage = (props: B2BRefreshMessageProps) => {
  const { t } = useTranslation();
  const desktop = useUpMedia('md');
  const provider = getB2BLobbyName();
  const message = provider
    ? t('B2B_REFRESH_MESSAGE', { provider })
    : t('B2B_REFRESH_MESSAGE_GENERIC');

  return (
    <Wrapper {...props}>
      <Overlay>
        {desktop ? (
          <StyledDesktopText
            asTag="h2"
            variant="h1"
            align="center"
          >
            {message}
          </StyledDesktopText>
        ) : (
          <StyledMobileText
            asTag="h2"
            variant="h1"
            align="center"
          >
            {message}
          </StyledMobileText>
        )}
      </Overlay>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.8);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
`;

const Overlay = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.responsive(40)};
  background-color: ${({ theme }) => theme.getColor('rgbaBlockBgColor')};
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  border-radius: ${({ theme }) => theme.responsive(20)};
  min-width: 300px;
  max-width: 500px;
  width: 90vw;
`;

const StyledDesktopText = styled(DesktopText)`
  text-align: center;
  font-weight: 600;
  color: ${({ theme }) => theme.getColor('completelyWhite')};
  white-space: pre-line;
`;

const StyledMobileText = styled(MobileText)`
  text-align: center;
  font-weight: 600;
  color: ${({ theme }) => theme.getColor('completelyWhite')};
  white-space: pre-line;
`;

export { B2BRefreshMessage };
